import { createStyles, makeStyles } from "@material-ui/core";

export const useSubscriptionCardStyles = makeStyles((theme) =>
  createStyles({
    subscriptionCardContainer: {
      maxWidth: 400,
      display: "flex",
      flexDirection: "column",
      width: "100%",
      position: "relative",
      border: `1px solid ${theme.palette.grey[400]}`,
      borderRadius: 12,
      height: "100%",
      overflow: "hidden",
    },
  }),
);
